<div class="flex">
  <ng-container *ngFor="let status of filteredStatus; trackBy: trackByValue">
    <lum-ui-label
      class="mr-2"
      [label]="status"
      [cssClasses]="status | picklistItemClass"
    ></lum-ui-label>
  </ng-container>
</div>
